import { PageMetaProps } from '../../components/ProfileMeta'

export default function getHomeSchema({ meta, locale }: { meta: PageMetaProps; locale: string }) {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Doctify',
    description: meta.description,
    url: `https://www.doctify.com/${locale}`,
    logo: meta.preloadImage,
    sameAs: [
      'https://twitter.com/doctifyuk',
      'https://www.facebook.com/doctifyuk',
      'https://www.linkedin.com/company/doctify',
      'https://www.youtube.com/@doctify'
    ]
  }

  return JSON.stringify([organizationSchema])
}
